import { useState, type FormEvent } from "react";
import { Link, Navigate, useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { Button, EmptyState, Field, Input } from "@agentsaas/ui";
import { Loading } from "../layout/Loading";
import { useErrorText, useT } from "../app/i18n";
import { useServices } from "../app/services";
import { qk, useTenants } from "../data/queries";

/** 首页：只有一个工作区时直接进入；否则列出供选择；没有则创建 */
export function HomePage() {
  const { t } = useT();
  const tenants = useTenants();
  if (tenants.isPending) return <Loading />;
  const items = tenants.data ?? [];
  if (items.length === 1) return <Navigate to={`/t/${items[0]!.id}`} replace />;
  return (
    <div className="page">
      <div className="page__head">
        <h1 className="page__title">{t("tenant.title")}</h1>
      </div>
      {items.length ? (
        <ul className="list card" style={{ padding: 0 }}>
          {items.map((x) => (
            <li key={x.id}>
              <Link className="list-item" to={`/t/${x.id}`}>
                <span className="grow">{x.name}</span>
                <span className="muted small">{x.slug}</span>
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <EmptyState icon="users" title={t("tenant.empty")} />
      )}
      <CreateTenant />
    </div>
  );
}

function CreateTenant() {
  const { t } = useT();
  const errText = useErrorText();
  const { api } = useServices();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const tn = await api.call("tenantCreate", { body: { name, slug } });
      await qc.invalidateQueries({ queryKey: qk.tenants });
      navigate(`/t/${tn.id}`);
    } catch (err) {
      setError(errText(err));
    }
  };
  return (
    <form className="card" style={{ marginTop: "var(--space-4)" }} onSubmit={submit}>
      <h2 className="page__title small">{t("tenant.create")}</h2>
      <Field label={t("tenant.name")}>{(id) => <Input id={id} value={name} onChange={(e) => setName(e.target.value)} />}</Field>
      <Field label={t("tenant.slug")} hint={t("tenant.slug_hint")} error={error ?? undefined}>
        {(id, d) => <Input id={id} aria-describedby={d} value={slug} onChange={(e) => setSlug(e.target.value.toLowerCase())} />}
      </Field>
      <Button type="submit" variant="primary">
        {t("common.create")}
      </Button>
    </form>
  );
}
